import qixSchema from 'enigma.js/schemas/12.170.2.json'
import { logger } from '~/utils/logger'

//const funcvar = {
async function getQIXConfig({ env }) {
  //Updated spree testing version of app with new enr version
  const appId = env.appID
  // useIPC
  //   ? '0a426c61-773b-4e6e-b24e-e9792a46209c'
  //   : testing
  //   ? 'e20b026b-6fbd-474f-83c6-b71973a004e9'
  //   : '3a3328a3-11fd-4ab9-9bfd-45d590d8b766'

  const host = env.qlikPublicUrl

  const ws_protocol = env.isLocal ? 'ws' : 'wss'
  const secure = env.isLocal ? false : true

  const url = `${ws_protocol}://${host}/app/engineData`

  const qix = {
    schema: qixSchema,
    host,
    port: 443,
    secure,
    prefix: '',
    url, //: 'wss://' + host + '/app/engineData',
    appId,
    suspendOnClose: false,
    responseInterceptors: [
      {
        onRejected: function retryAbortedError(
          sessionReference,
          request,
          error
        ) {
          if (
            error.code ===
            qixSchema.enums.LocalizedErrorCode.LOCERR_GENERIC_ABORTED
          ) {
            request.tries = (request.tries || 0) + 1
            logger.warn(`Request: Retry #${request.tries}`)
            if (request.tries <= 3) {
              return request.retry()
            }
          }
          return this.Promise.reject(error)
        }
      }
    ]
  }

  return qix
}
//}

export default async ({ app }, inject) => {
  const qix = await getQIXConfig({ env: app.$env })

  inject('qix', qix)

  logger.debug('QIX function injected, ', app.$qix)
  logger.debug('qix_new - server ', process.server, 'client', process.client)
  logger.debug('QIX function injected, ', app.$qix.url)
}
